import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from './components/Icon';
import Routes from '../../routes';
import './index.css';

class Nav extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hideNav: false,
            isMobile: false
        }

        this.toogleMenu = this.toogleMenu.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));

        this.resize();
    }

    toogleMenu() {
        if(this.state.isMobile) this.setState(prev => ({ hideNav: !prev.hideNav }))
    }

    resize() {
        const isMobile = (window.innerWidth <= 760);

        this.setState({ isMobile, hideNav: isMobile });
    }

    render() {
        const { hideNav } = this.state;

        return (
            <nav className="navbar navbar-inverse navbar-fixed-top">
                <div className="navbar-header">
                    <button onClick={this.toogleMenu} type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-ex1-collapse">
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                    </button>

                    <span className="navbar-brand">TwoSignal</span>
                </div>


                <div className={hideNav && 'collapse'} style={{ overflow: 'auto', padding: '0px 15px' }}>
                    <ul className="nav navbar-nav side-nav" style={{ height: this.state.isMobile ? "70vh" : "100vh" }}>
                        {
                            Routes.map((route, index) => {
                                if(route.notForNav) return null;

                                if(route.type === 'folder') {
                                    const routes = route.routes.map((route, index) => <NavLink onClick={this.toogleMenu} key={index} exact to={route.path} activeClassName="cs-nav-active"><Icon name={route.icon}/> {route.name}</NavLink>);

                                    return (
                                        <li className={'nav-group'} key={index}>
                                            <label htmlFor={route.name}>{route.name}</label>
                                            <input type="checkbox" id={route.name}/>
                                            <div className="nav-folder">
                                                {routes}
                                            </div>
                                        </li>
                                    )
                                }

                                return (
                                    <li key={route.path}>
                                        <NavLink onClick={this.toogleMenu} exact to={route.path} activeClassName="cs-nav-active"><Icon name={route.icon}/> {route.name}</NavLink>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            </nav>
        );
    }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav/index.js